import React, { Component } from 'react';
import { Switch, Button, Dropdown, Menu, Empty, Modal, Pagination } from 'antd';
import { DownOutlined, UserOutlined, StarFilled, InsertRowBelowOutlined, LayoutOutlined, InsertRowLeftOutlined, BgColorsOutlined, MenuOutlined, AppstoreOutlined, UnorderedListOutlined, PieChartOutlined, SlidersOutlined, DashboardOutlined, SwapOutlined, EllipsisOutlined, AimOutlined, EditOutlined, FundViewOutlined, SendOutlined } from '@ant-design/icons';
// import CustomLoader from '../../components/loader';
// import networkList from '../../constants/networkList';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
// import InnerTime from '../../common/pages/InnerTime';
import Storage from '../../../services/local-store';
import Select2 from  '../../../components/FormComponent/select2'

const { getOnbedPatientsForNurse, homepage } = networkList;
let i = 0;
class On_bed_patient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            switch_grid: true,
            id: null,
            loadding: false,
            message: null,
            list: [],
            tbody: [],
            tableData: [],
            assigned_patient: [],
            activePage: 1,
            totalItemsCount: 0,
            search_key:'',
            formData: [{
                id: 1,
                name: 'dmo_assign_wardsDropDown',
                text: 'patient Name or UMR or IP',
                visible: true,
                element: 'input',
                required: true,
                input_type: 'text',
                placeholder: 'patient Name or UMR or IP',
                icon: 'lock',
                rules: [
                    {
                        test: (value) => {
                            return (value !== null && value.length > 0);
                        },
                        message: 'Please Select Ward'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: ['w-100 form-control']
            }],
            ward_id: null,
            patient_details:[],
        }
    }
    componentDidMount() {
        localStorage.removeItem('patient_details')
        this.fetchListData();
    }

    fetchListData() {
        const { id } = this.props.match.params;
        let { activePage,search_key} = this.state;
        let user_data = JSON.parse(localStorage.getItem('user_data'));

        this.setState((state) => ({ tbody: [], loadding: true }));
        try {
            postService(getOnbedPatientsForNurse, 'POST', { 'data': {"search_key":search_key, "page_no": activePage, "unit_id":user_data && user_data['unitid']} }).then(res => {
                if (res.status === true) {
                    this.setState((state) => ({
                        assigned_patient: res.data,
                        message: res.message,
                        loadding: false,
                        totalItemsCount: res.total_items,
                    }));
                } else {
                    this.setState({ loadding: false })
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                    })
                }
            })
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ loadding: false }));

            Modal.error({
                title: 'Failure',
                content: 'Oops, something is wrong. Please try again.',
            })

        }
    }

    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }
    handlePageChange(page) {
        console.log(page);
        this.setState((state) => ({
            activePage: page,
            assigned_patient: []
        }), () => {
            this.fetchListData();
        })
    }

    searchClick() {
        i = 0;
        this.setState((state) => ({ 'page_data_count': 1 }), () => {
            this.fetchListData();
        })
    }
   
    searchChange(e) {
        console.log(e.target.value);
        let value = e.target.value
        i = 0;
        this.setState((state) => ({ 'search_key': value }), () => {
        });
    }
    gettheDetailpage(data){
        Storage.store('patient_details', data)
        this.props.history.push('/patients/on-bed-patient-details?patient_ip=' + data['patient_ip_number']+`&umr_no=`+data['umr_no'])
    }

    render() {
        const { alert, alertmenu, menu, loadding, message, assigned_patient, switch_grid, totalItemsCount, formData } = this.state;
        var Username = JSON.parse(Storage.get('uname'));
        return (
            <React.Fragment>
                <div className="pt-4 mx-5">
                    {/* {loadding && <CustomLoader />} */}
                    <div className="row">
                        <div className="col-12">
                            <div className="row my-2 mb-3">
                                <div className="col-4">
                                </div>
                                {formData.map((feild, key) => {
                                     if (feild.element === 'input' && feild.visible) {
                                        return (
                                            <div className="col-4 ">
                                                <div class="input-group">
                                                    <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" onBlur={this.searchChange.bind(this)} ref={(inputRef => (this.inputRef = inputRef))} />
                                                    <div class="input-group-append">
                                                        <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }})}
                            </div>
                            <div className="row das-fixed-height">
                                {assigned_patient && assigned_patient.map((data, key) => {
                                    return (
                                        <div className={`${switch_grid ? 'col-3' : 'col-12'} pr-0 mb-3`}>
                                            <div className="card border-0 dmo-card h-100">
                                                <div className="card-header bg8">
                                                     <div className="cardheadertext"><i class="fas fa-user on-bed-icon"></i>{data.patient_name}</div>
                                                </div>
                                                <div className="card-body on-bed-cardb" style={{ cursor: 'pointer' }} onClick={() => { this.gettheDetailpage(data) }}>
                                                    <div className={`${switch_grid ? 'd-block' : 'd-flex'}`}>
                                                        <div className={`${switch_grid ? 'd-flex' : 'd-block w-25'}`}>
                                                            <p className="card-label"><i class="fas fa-venus-mars on-bed-icon"></i></p>
                                                            <p className="card-data text-uppercase">{data.patient_age}/{data.patient_gender ? (data.patient_gender).charAt(0) : '-'}</p>
                                                        </div>
                                                         <div className={`${switch_grid ? 'd-flex' : 'd-block w-25'}`}>
                                                            <p className="card-label"><i class="fas fa-hashtag on-bed-icon"></i></p>
                                                            <p className="card-data">{data.umr_no ? data.umr_no : '--'}</p><span className="mx-3">|</span> <p className="card-data ">{data.patient_ip_number ? data.patient_ip_number : '--'}</p>
                                                        </div>
                                                        <div className={`${switch_grid ? 'd-flex' : 'd-block w-25'}`}>
                                                            <p className="card-label"><i class="fas fa-user-md on-bed-icon"></i></p>
                                                            <p className="card-data on-bad-p">DR. {data.doctor_name ? data.doctor_name : '--'}</p>
                                                        </div>
                                                        <div className={`${switch_grid ? 'd-flex' : 'd-block w-25'}`}>
                                                            <p className="card-label"><i class="fas fa-money-bill-alt on-bed-icon"></i></p>
                                                            <p className="card-data">{data.payer_type ? data.payer_type : '--'}</p>
                                                        </div>
                                                        <div className={`${switch_grid ? 'd-flex' : 'd-block w-25'}`}>
                                                            <p className="card-label"><i class="fas fa-procedures on-bed-icon"></i> </p>
                                                            <p className="card-data"> {data.bed_no?data.bed_no:'--'}</p>
                                                        </div>
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                {assigned_patient.length == 0 && <Empty className="mx-auto" description={
                                    <span>
                                        {message ? message : 'Fetching Data...'}
                                    </span>
                                } />}
                                <div className="col-12 justify-content-center align-item-center mx-0">
                                    <div className="col pagenation-col mb-3">
                                        <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={20} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />
                                    </div>
                                </div>
                            </div>


                        </div>
                        {/* <div className="col-3 dmo-alert">
                            <h1 className="my-2 mb-3">Alerts {alert && alert.length > 0 && `(${alert.length})`}</h1>
                            {/* <hr></hr> */}
                            {/* <div className="das-fixed-height">
                                {alert && alert.map((data, key) => {
                                    return (<div>
                                        <div style={{ height: '20px' }}>

                                            <Dropdown overlay={alertmenu} trigger={['click']} placement="bottomRight">
                                                <EllipsisOutlined style={{ color: '#000', fontSize: '25px' }} />
                                            </Dropdown>
                                        </div>
                                        <p>{data.patient} {data.age}/{data.gender} {data.doctor} {data.department} <span className="text-success">{data.value}</span> ({data.range})</p>
                                        <hr />
                                    </div>)
                                })}
                                {alert.length == 0 && <Empty description={
                                    <span>
                                        {message ? message : 'Fetching Data...'}
                                    </span>
                                } />}
                            </div>
                        </div>  */}

                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default On_bed_patient;